import axios from 'axios';
import { setAlert } from './alert';

import {
    GET_WIKI_PAGES,
    ADD_WIKI_PAGE,
    UPDATE_WIKI_PAGE,
    WIKI_ERROR
} from './types';

//Get all wiki pages in db
export const getWikiPages = () => async dispatch => {
    try {
        const res = await axios.get('/api/wiki');

        dispatch({
            type: GET_WIKI_PAGES,
            payload: res.data
        });
    } catch (err) {
        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: WIKI_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}

//Add wiki page to database
export const addWikiPage = (wikiObject, navigate) => async dispatch => {

    console.log(wikiObject);

    try {
        const res = await axios.post('/api/wiki', wikiObject);

        dispatch({
            type: ADD_WIKI_PAGE,
            payload: res.data
        });

        navigate('/wiki');

        dispatch(setAlert('Wiki Page Created','success', 2000));

        
    } catch (err) {
        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: WIKI_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}

//Update wiki page
export const updateWikiPage = (wikiObject, navigate) => async dispatch => {
    try {

        const res = await axios.post(`/api/wiki/${wikiObject._id}`, wikiObject);
        
        dispatch({
            type: UPDATE_WIKI_PAGE,
            payload: res.data
        });

        navigate('/wiki');

    } catch (err) {
        dispatch({
            type: WIKI_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}